import React, { useState, useEffect } from 'react'
import { getDocumentsList } from '../../../../../../service-layer/StorageService'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useStateContext } from '../../../../../../contextProvider';

import { CListGroup, CListGroupItem, CRow, CCol, CModal, CModalHeader, CModalTitle, CModalBody} from '@coreui/react';

import ClipLoader from "react-spinners/ClipLoader";
import LogoutModal from '../../../../../components/logout-moal/LogoutModal';

import DocumentsTable from './DocumentsTable';
import { TryRounded } from '@mui/icons-material';
import DocumentButton from './DocumentButton';
import { filter } from 'jszip';

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import { AG_GRID_LOCALE_IT, AG_GRID_LOCALE_EN } from '@ag-grid-community/locale';



const DocumentsPage = () => {

  const [documentsList, setDocumentsList] = useState([])
  const [loadingList, setLoadingList] = useState(true)
  

  const [showLogoutModal, setShowLogoutModal] = useState(false);  // logout modal
  const [showGetError, setShowGetError] = useState(false) // messaggio errore caricamento

  // const [gridOptions, setGridOptions] = useState({});

  // STATES & CONTEXT
const { selectedPatient, setSelectedPatient, selectedPatientData, 
    setSelectedPatientData, doctorPage, setDoctorPage, selectedDocument, setSelectedDocument,
    documentURL, setDocumentURL, documentURLType, setDocumentURLType } = useStateContext()   // stati condivisi

  const navigate = useNavigate();
  const { t } = useTranslation()


  const setSelectedRow = (event) => {
    const selectedNode = event.node;
    const document = selectedNode.data.fileName
    // console.log("SELECTED DOCUMENT", document)
    setSelectedDocument(document)
}
  

  // COLONNE TABELLA
  const cols = [
    {
        field: "fileName", 
        headerName: t("fileName"),
        sortable: true,
        filter: true,
        floatingFilter: true
    },
    {
        field: "loadingDate", 
        headerName: t("loadingDate"),
        sortable: true,
        // filter: false,
        valueFormatter: (params) => {
          // if(t('volte') === 'volte')
          //   return params.value
          // else{
          //   console.log("params.value", params.value)
          //   const [date_part, time_part] = params.value.split(', ')
          //   const [month, day, year] = date_part.split('/')
          //   return `${day}/${month}/${year}, ${time_part}`
          // }
          // console.log("params.value", params)
          // const date = new Date(params.value)
          console.log("newDate", params.value)
          const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: t('volte') !== 'volte',
            timeZone: 'Europe/Rome'
          };
          const locale = t('volte') === 'volte' ? 'it-IT' : 'en-GB';
          return new Intl.DateTimeFormat(locale, options).format(params.value);
            

                  // const romeTimeFormatter = new Intl.DateTimeFormat(t('volte') === 'volte' ? "it-IT" : "en-GB", {
                  //   timeZone: "Europe/Rome",
                  //   year: "numeric",
                  //   month: "2-digit",
                  //   day: "2-digit",
                  //   hour: "2-digit",
                  //   minute: "2-digit",
                  //   hour12: t('volte') !== 'volte'
                  // });
            return params.value
        
                }
      //   filter: 'agDateColumnFilter',
      //   filterParams: {
      //     dateFormatter: (date) => {
      //       if (date) {
      //         const month = String(date.getMonth() + 1).padStart(2, '0');
      //         const day = String(date.getDate()).padStart(2, '0');
      //         const year = date.getFullYear();
      //         return `${month}/${day}/${year}`;
      //       }
      //       return '';
      //       }, 
      //     // provide comparator function
      //     comparator: (filterLocalDateAtMidnight, cellValue) => {
      //         const dateAsString = cellValue;
      //         // console.log("DATE AS STRING", dateAsString)
      //         if (dateAsString == null) {
      //             return 0;
      //         }

      //         // In the example application, dates are stored as dd/mm/yyyy
      //         // We create a Date object for comparison against the filter date
      //         const datepart = dateAsString.split(',')[0]
      //         const dateParts = datepart.split('/');
      //         const year = Number(dateParts[2]);
      //         const month = Number(dateParts[1]) - 1;
      //         const day = Number(dateParts[0]);
      //         const cellDate = new Date(year, month, day);

      //         // Now that both parameters are Date objects, we can compare
      //         if (cellDate < filterLocalDateAtMidnight) {
      //             return -1;
      //         } else if (cellDate > filterLocalDateAtMidnight) {
      //             return 1;
      //         }
      //         return 0;
      //     }
      // },
      // floatingFilter: true,
    },
    {
        field: "documentOptions", 
        headerName: t("documentOptions"),
        sortable: false,
        filter: false,
        cellRenderer: DocumentButton,
    }
  ]

  
  useEffect(() => {
    if (window.localStorage.getItem("auth_token") === null) navigate("/login");
  }, [navigate]);


  const token = window.localStorage.getItem("auth_token");


  // lista dei file caricati dall'utente
  useEffect(() => {
    console.log("SELECTED PATIENT NOW", selectedPatient)
    getDocumentsList(selectedPatient).then((response) => {
      console.log("DOC LIST", response.data)

        const docList = response.data.files.filter((_, ind) => ind >= 0).sort((a,b) => b.uploadDate - a.uploadDate).map((doc) => {

            return {
                fileName: doc.fileName.split('/').slice(-1)[0],
                loadingDate: new Date(doc.uploadDate),
                documentOptions: ''
            }
        })


        console.log("DOCUMENTS LIST", docList)
        setLoadingList(false)
        setDocumentsList(docList)
        setShowGetError(false)
        setShowLogoutModal(false)
    })
    .catch((err) => {
        console.error(err)
        setShowGetError(true)
        setLoadingList(false)
        setShowLogoutModal(true);
    })
  }, [])


  // useEffect(() => {
  //   return () => setGridOptions({
  //     localeText: t('documentsPage') === 'Documenti' ? AG_GRID_LOCALE_IT : AG_GRID_LOCALE_EN,
  //   })
  // }, [])

  // FUNCTION TO HANDLE LOGOUT
    const handleConfirm = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("name");
        localStorage.removeItem("surname");
        localStorage.removeItem("authority");
    
        localStorage.removeItem("doctor_page");
        localStorage.removeItem("patient_id");
        localStorage.removeItem("staff_id");
        localStorage.removeItem("patient_data");
    
        localStorage.removeItem("patient_name");
        localStorage.removeItem("patient_surname");
    
        setSelectedPatient(undefined)
        setSelectedPatientData(undefined)
        setDoctorPage(undefined)
    
        setShowLogoutModal(false);
        navigate("/");
    };

  return (
    <>
    <ToastContainer
                position="top-center"
                className="Toastify__toast-container--center"
    />
    {
        token && !loadingList && documentsList.length > 0 &&
        <div
        className="dashboard d-flex grid-container"
        style={{
          flex: "1 1 auto",
          display: "flex",
          flexFlow: "column",
          height: "100vh",
          overflowY: "auto"}}>
            <div
            style={{
                flex: "1 1 auto",
                display: "flex",
                flexFlow: "column",
                height: "100vh",
                overflowY: "auto",
                padding: '10px'
              }}>
                <DocumentsTable 
                    documents={documentsList}
                    columns={cols}
                    setSelectedRow={setSelectedRow}
                    selectedDocument={selectedDocument}
                    // gridOptions={gridOptions}
                />
            
            </div>
        </div>
    }
    {
      token && !loadingList && documentsList.length === 0 && !showGetError &&
      <div
          style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
          }}
      >
          <h3>{t("no_documents")}</h3>
      </div>
    }
    {
      token && !loadingList && showGetError &&
      <div
          style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: 'red'
          }}
      >
          <h3>{t("documentsError")}</h3>
      </div>
    }
    {
      documentURL !== 'previewError' && documentURL !== 'downloadError' && documentURL !== undefined && !loadingList && documentsList.length > 0 &&
      <CModal
        visible={documentURL !== undefined}
        onClose={() => {
          setDocumentURL(undefined)
          setDocumentURLType(undefined)
        }}
        backdrop="static"
        size='xl'
      >
        <CModalHeader>
          <CModalTitle>{selectedDocument}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width:"100%",
            height:"550px",
            overflow: 'hidden'
          }}>
            { documentURLType.includes('pdf') &&
              <embed
                src={documentURL}
                type="application/pdf"
                width="100%"
                height="100%"
              />
            }
            {
              documentURLType.includes('image') && 
              <img 
                src={documentURL}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain'
                }}
              />
            } 
          </div>
        </CModalBody>
      </CModal>
    }
    {!token && <div className="login-container"></div>}
      <LogoutModal
        show={showLogoutModal}
        handleConfirm={handleConfirm}
        handleClose={handleConfirm}
        title={t("login")}
        message={t("session_expired_please_login_again")}
        tag={"Login"}
      />
      {
        loadingList && 
        <div
          style={{
            height: "100%",
            width: '100%',
            display: "flex",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ClipLoader
            color="#204770"
            loading={loadingList}
            // cssOverride={override}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
        </div>
      }
    </>
  )
}

export default DocumentsPage